module.exports = __webpack_public_path__ + "img/illustration-4.c6f214d3.svg";